import React, { Component, Fragment } from "react";
import moment from "moment";
import "moment/locale/ru";
import PropTypes from "prop-types";
import momentPropTypes from "react-moment-proptypes";
import { withStyles, withStylesPropTypes, css } from "react-with-styles";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import {
  DateRangePicker,
  isSameDay,
  isInclusivelyBeforeDay
} from "react-dates";

import "./component_style.css";

const START_DATE = "startDate";
const END_DATE = "endDate";

moment.locale("ru");

const today = moment();

class DatePicker extends Component {
  state = {
    startDate: this.props.initialStartDate,
    endDate: this.props.initialEndDate,
    focusedInput: null
  };

  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.initialStartDate &&
        nextProps.initialStartDate !== this.state.startDate) ||
      (nextProps.initialEndDate &&
        nextProps.initialEndDate !== this.state.endDate)
    ) {
      this.setState({
        ...this.state,
        startDate: nextProps.initialStartDate,
        endDate: nextProps.initialEndDate
      });
      this.onFocusChange(null);
    }
  }

  onFocusChange = focusedInput => {
    this.setState({ focusedInput });
    // if (this.state.focusedInput === "endDate" && !focusedInput) {

    // }
  };

  onDatesChange = ({ startDate, endDate, presets }) => {
    const { onChange } = this.props;
    const { focusedInput } = this.state;
    this.setState({ startDate, endDate: endDate || startDate });

    onChange &&
      endDate &&
      (focusedInput === "endDate" || presets) &&
      onChange(null, {
        startDate: (startDate || "").toString(),
        endDate: (endDate || "").toString()
      });

    // if (presets) {
    //   this.onFocusChange(null);
    // }
  };

  renderDatePresets = () => {
    const { presets, styles } = this.props;
    const { startDate, endDate } = this.state;
    return (
      <div {...css(styles.PresetDateRangePicker_panel)}>
        {presets.map(({ text, start, end }) => {
          const isSelected =
            isSameDay(start, startDate) && isSameDay(end, endDate);
          return (
            <button
              key={text}
              {...css(
                styles.PresetDateRangePicker_button,
                isSelected && styles.PresetDateRangePicker_button__selected
              )}
              type="button"
              onClick={() => {
                this.onDatesChange({
                  startDate: start,
                  endDate: end,
                  presets: true
                });
              }}
            >
              {text}
            </button>
          );
        })}
      </div>
    );
  };

  onClickHandler = () => {
    this.onFocusChange("startDate");
  };

  render() {
    const { focusedInput, startDate, endDate } = this.state;
    const { isOutsideRange } = this.props;
    const startDateString = startDate && startDate.format("DD.MM.YYYY");
    const endDateString = endDate && endDate.format("DD.MM.YYYY");

    return (
      <Fragment>
        <span onClick={this.onClickHandler}>
          {startDateString}-{endDateString}
        </span>
        <DateRangePicker
          // {...input}
          startDateId="picker-start"
          endDateId="picker-end"
          startDate={startDate}
          verticalSpacing={-17}
          endDate={endDate}
          renderCalendarInfo={this.renderDatePresets}
          onDatesChange={this.onDatesChange}
          focusedInput={focusedInput}
          onFocusChange={this.onFocusChange}
          isOutsideRange={isOutsideRange}
          startDatePlaceholderText="00.00.00"
          endDatePlaceholderText="00.00.00"
          // keepOpenOnDateSelect={true}
          readOnly={true}
          // initialVisibleMonth={() => moment().subtract(1, "months")}
          minimumNights={0}
          hideKeyboardShortcutsPanel={true}
          // displayFormat={() => moment.localeData().longDateFormat("LL")}
        />
      </Fragment>
    );
  }
}

DatePicker.propTypes = {
  ...withStylesPropTypes,
  autoFocus: PropTypes.bool,
  autoFocusEndDate: PropTypes.bool,
  initialStartDate: momentPropTypes.momentObj,
  initialEndDate: momentPropTypes.momentObj,
  presets: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      start: momentPropTypes.momentObj,
      end: momentPropTypes.momentObj
    })
  )
};

DatePicker.defaultProps = {
  autoFocus: false,
  autoFocusEndDate: false,
  initialStartDate: null,
  initialEndDate: null,
  presets: [],
  // input related props
  startDateId: START_DATE,
  startDatePlaceholderText: "00.00.00",
  endDateId: END_DATE,
  endDatePlaceholderText: "00.00.00",
  disabled: false,
  required: true,
  screenReaderInputMessage: "",
  showClearDates: false,
  showDefaultInputIcon: false,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,
  // calendar presentation and interaction related props
  renderMonth: null,
  // orientation: HORIZONTAL_ORIENTATION,
  // anchorDirection: ANCHOR_LEFT,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  // initialVisibleMonth: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  isRTL: false,
  // day presentation and interaction related props
  renderDayContents: null,
  minimumNights: 0,
  enableOutsideDays: false,
  isDayBlocked: () => false,
  isOutsideRange: day => !isInclusivelyBeforeDay(day, today),
  isDayHighlighted: () => false
};

export default withStyles(({ reactDates: { color } }) => ({
  PresetDateRangePicker_panel: {
    //padding: "0 22px 11px 22px"
  },

  PresetDateRangePicker_button: {
    position: "relative",
    //height: "100%",
    //textAlign: "center",
    //background: "none",
    //border: `2px solid ${color.core.primary}`,
    //color: color.core.primary,
    //padding: "4px 12px",
    //marginRight: 8,
    font: "inherit",
    //fontWeight: 700,
    //lineHeight: "normal",
    //overflow: "visible",
    //boxSizing: "border-box",
    cursor: "pointer",

    ":active": {
      outline: 0
    }
  },

  PresetDateRangePicker_button__selected: {
    color: color.core.white,
    background: color.core.primary
  }
}))(DatePicker);
